module.exports = __webpack_public_path__ + "59ae0b4269df82020a0f13ffc8a83db6.pdf";